import React from "react";
import {
  AppstoreOutlined,
  FileSearchOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UpCircleOutlined,
  FormOutlined,
  SettingOutlined
} from "@ant-design/icons";
import { Menu, Layout } from "antd";
import "../SideBar/Sidebar.css";
import Cookies from "js-cookie";
import { useState } from "react";
import Logout from "../Logout/Logout";
import { useHistory } from "react-router-dom";
const { Sider } = Layout;

export const ActivePage = (key) => {
  if (localStorage.getItem("ActivePage")) {
    localStorage.removeItem("ActivePage");
    localStorage.setItem("ActivePage", key);
  } else {
    localStorage.setItem("ActivePage", key);
  }
};

const SideNavBar = () => {
  let history = useHistory();

  const [collapsed, setCollapsed] = useState(true);
  // const location = useLocation();
  const Role = Cookies.get("Role");
  const isAdmin = Role === "Super User";

  const goToDashboard = () => {
    // setSelectedWindow(e.key);
    ActivePage("1");
    if (Role === "Super User") {
      window.location.href = "/admin-dashboard";
    }
    else {
      window.location.href = "/dashboard";
    }
  };
  const goToUtilities = () => {
    ActivePage("5");
    window.location.href = "/utilities";
  };
  const goToCredentialUpdate = () => {
    ActivePage("6");
    window.location.href = "/updatecredentialGrid";
  };
  const goToUserManagement = () => {
    ActivePage("7");
    window.location.href = "/usermanagement";
  };
  
  const goToGarnishments = () => {
    ActivePage("subitem3");
    window.location.href = "/garnishments";
  }
  const goToTimecards = () => {
    // setSelectedWindow("2");
    ActivePage("subitem4");
    window.location.href = "/timecards";
  };
  const goToMasterFile = () => {
    ActivePage("subitem5");
    window.location.href = "/masterfile";
  };
  const goToTAdjustments = () => {
    // setSelectedWindow("3");
    ActivePage("subitem6");
    window.location.href = "/adjustments";
  };
  const goToTAudit = () => {
    // setSelectedWindow("6");
    ActivePage("subitem7");
    window.location.href = "/audit";
  };
  const gotoFinalMasterAudit = () => {
    ActivePage("subitem8");
    window.location.href = "./finalmasteraudit"
  }
  const goToNewHiresReHires=()=>{
    ActivePage("subitem1");
    window.location.href = "/newhiresrehires";

  }

  const goToHealthInsurance = () => {
    ActivePage("subitem2");
    window.location.href = "/healthinsurance";
  }

  const goToOffCycle = () => {
    ActivePage("offcycle");
    history.push("/offcycle");
  }
  
  const goToExpenses = () => {
    // setSelectedWindow("6");
    ActivePage("4");
    window.location.href = "/expensemanagement";
  };
 
  
  return (
    <>
      <div className={collapsed ? "sider-collapsed" : "whole-sider-class"}>
        <Sider
          collapsible
          collapsed={collapsed}
          theme="light"
          trigger={null}
          onCollapse={(value) => setCollapsed(value)}
          className="sider-class"
        // width={"100%"}
        >
          {/* <div /> */}
          <div className="header-intime">
            <div className="sider-header">
              {collapsed ? (
                <div className="trigger-wrapper">
                  {React.createElement(MenuUnfoldOutlined, {
                    className: "trigger",
                    onClick: () => setCollapsed(!collapsed),
                  })}
                </div>
              ) : (
                <>
                  {React.createElement(MenuFoldOutlined, {
                    className: "trigger",
                    onClick: () => setCollapsed(!collapsed),
                  })}
                  <span className="sider-title">INTIME</span>
                </>
              )}
            </div>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[localStorage.getItem('ActivePage')]}
            defaultSelectedKeys={['1']}
            className="items-class"
          >
            <Menu.Item key="1" icon={<img src="./Images/primary.png" alt="Dashboard" style={{ fontSize: 23, marginRight: 8 }} />} onClick={goToDashboard}>
              Dashboard
            </Menu.Item>
            <Menu.SubMenu
              key="2"
              icon={<img src="./Images/Group 843.png" alt="Regular Payroll" style={{ fontSize: 23, marginRight: 8 }} />}
              title={"Regular Payroll"}
            >
              <Menu.Item key="subitem1" className="menuicon-class" onClick={goToNewHiresReHires} >
                Newhires/Rehires
              </Menu.Item>
              <Menu.Item key="subitem2" className="menuicon-class" onClick={goToHealthInsurance}>
                Health Insurance
              </Menu.Item>
              <Menu.Item key="subitem3" className="menuicon-class" onClick={goToGarnishments}>
                Garnishments
              </Menu.Item>
              <Menu.Item key="subitem4" className="menuicon-class" onClick={goToTimecards}>
                Timecards
              </Menu.Item>
              <Menu.Item key="subitem5" className="menuicon-class" onClick={goToMasterFile}>
                Payroll Masterfile
              </Menu.Item>
              <Menu.Item key="subitem6" className="menuicon-class" onClick={goToTAdjustments}>
                Payroll Adjustments
              </Menu.Item>
              <Menu.Item key="subitem7" className="menuicon-class" onClick={goToTAudit}>
                Payroll Audit/Review
              </Menu.Item>
              <Menu.Item key="subitem8" className="menuicon-class" onClick={gotoFinalMasterAudit}>
                Final Master Audit
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item key="offcycle" className="menuicon-class"  icon={<img src="./Images/Group 844.png" alt="Off Cycle Payroll" style={{ fontSize: 23, marginRight: 8 }} />}onClick={goToOffCycle}>
              Off Cycle Payroll
            </Menu.Item>
            <Menu.Item key="4"  icon={<img src="./Images/Group 845.png" alt="Expense Management" style={{ fontSize: 23, marginRight: 8 }} />} onClick={goToExpenses}>
              Expense Management
            </Menu.Item>
            <Menu.Item key="5"  icon={<img src="./Images/Group 846.png" alt="Utilities" style={{ fontSize: 23, marginRight: 8 }} />} onClick={goToUtilities}>
              Utilities
            </Menu.Item>
            <Menu.Item key="6"icon={<img src="./Images/Group 848.png" alt="Creds Handling" style={{ fontSize: 23, marginRight: 8 }} />} onClick={goToCredentialUpdate}>
              Creds Handling
            </Menu.Item>
            {isAdmin && (
            <Menu.Item key="7" icon={<img src="./Images/solar_settings-linear.png" alt="User Management" style={{ fontSize: 23, marginRight: 8 }} />} onClick={goToUserManagement}>
              User Management
            </Menu.Item>
             )}
            <Menu.Item key="8" icon={<Logout  />} className="menu-label">Logout</Menu.Item>
          </Menu>
        </Sider>
        <div style={{ background: "white" }}>
          <div className="sider-header"></div>
          <div className="vertical-center">
            <div
              onClick={() => setCollapsed(!collapsed)}
            >
              {
                <img src={"./Images/sideopenarrow.png"} className="navigation-arrow-side-bar" />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideNavBar;